module.exports = __webpack_public_path__ + "img/15600.1a1c5d30.jpg";